import { ConfirmationLineTable } from "./ConfirmationLineTable";
import type { ConfirmationCategoryTableProps, ConfirmationTableColumn } from "./tableTypes";
import { confirmationTablePeopleSource, isConfirmationTableLumpSum } from "../../../service/confirmationTablePresentation";

/** 独立维护杂费项目、计费方式和数量期间的表格展示。 */
export function ConfirmationMiscTable({ common, table }: ConfirmationCategoryTableProps) {
  const { item, billing, role, quantity, count, price, amount, provider, tail } = common;
  const columns: ConfirmationTableColumn[] = [
    item,
    { ...billing, width: 112, render: (line, group) => isConfirmationTableLumpSum(line) ? "整项金额" : <>{billing.render(line, group)}{line.unit === "人" && <small>{confirmationTablePeopleSource(line)} · 来源未知</small>}</> },
    { ...role, label: "人数口径", width: 92, render: (line, group) => line.travelerRole ? role.render(line, group) : line.unit === "人" ? "口径未知" : "—" }, quantity("人数 / 项数"), count("天数 / 次数"), price, amount, provider, ...tail,
  ];
  return <ConfirmationLineTable {...table} columns={columns} variant="misc" />;
}
